import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import "./index.css";

const Container = styled.div(({ theme }) => css`
  background: ${theme.blueDark};
  display: flex;
  padding: 0 20px;
  height: 90px;
  align-items: center;
`)


const Loader = () => {
  return (
        <div className='wrap'>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
            <div className='c'></div>
        </div>

  )
}

export default Loader
